import { render, staticRenderFns } from "./CupboardInfo.vue?vue&type=template&id=48eb4204&scoped=true&"
import script from "./CupboardInfo.vue?vue&type=script&lang=js&"
export * from "./CupboardInfo.vue?vue&type=script&lang=js&"
import style0 from "./CupboardInfo.vue?vue&type=style&index=0&id=48eb4204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb4204",
  null
  
)

export default component.exports